import { UiModalDeclarationController } from './modal.declaration.controller';
import template from './modal.declaration.html';

export const uiModalDeclarationComponent = {
  name: 'uiModalDeclarationComponent',
  controller: UiModalDeclarationController,
  template,

  //The modal key is used to trigger the modal via the ui modal trigger directive
  bindings: {
    modalKey: '@',
    modalUrl: '@?',
    fullscreen: '<',
    modalClass: '<',
    onSuccess: '&',
    onDismiss: '&'
  },

  //Add content and action html. Action html will appear at bottom of the modal.
  transclude: {
    content: '?content',
    actions: '?actions'
  }
};
